import { render, staticRenderFns } from "./Item4.vue?vue&type=template&id=45408b67&scoped=true"
import script from "./Item4.vue?vue&type=script&lang=js"
export * from "./Item4.vue?vue&type=script&lang=js"
import style0 from "./Item4.vue?vue&type=style&index=0&id=45408b67&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45408b67",
  null
  
)

export default component.exports